import Ingredients from "./ingredients";

export default Ingredients;